import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "../../utils"

const badgeVariants = cva(
  "inline-flex items-center rounded-full px-2.5 py-0.5 text-xs text-center font-medium whitespace-nowrap",
  {
    variants: {
      variant: {
        default: "bg-gray-100 text-gray-600",
        active: "bg-badge-active-bg text-emerald-600",
        draft: "bg-badge-draft-bg text-badge-draft-text",
        inactive: "bg-gray-300 text-gray-700",
        outline:
          "border border-gray-200 bg-transparent text-gray-500",
        blue: "bg-blue-500/10 text-blue-500",
        green: "bg-emerald-600/10 text-emerald-600",
        yellow: "bg-amber-500/10 text-amber-700",
        red: "bg-rose-600/10 text-rose-600",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  },
)

function Badge({
  className,
  variant,
  ...props
}: React.ComponentProps<"span"> & VariantProps<typeof badgeVariants>) {
  return (
    <span
      data-slot="badge"
      className={cn(badgeVariants({ variant }), className)}
      {...props}
    />
  )
}

export { Badge, badgeVariants }
